import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import { Divider } from '@mui/material'

const VZTakesMiamiLakesByStorm = () => {
  return (
    <Box
      sx={{
        p: { xs: 2, md: 4 },
        backgroundColor: '#fff',
        minHeight: '100vh',
        maxWidth: 900,
        mx: 'auto',
      }}
    >
      <Typography variant="h3" gutterBottom>
        Vision Zero Takes Miami Lakes by Storm!
      </Typography>

      <Typography paragraph>
        Miami Lakers, we’ve got some exciting news to share: the Vision Zero team is kicking off a new
        chapter in our public engagement campaign, and we look forward to having <strong>YOU</strong>{' '}
        at the center of it!
      </Typography>

      <Typography paragraph>
        This month, we’re hitting the streets, reaching out to committees and strategic stakeholders,
        and popping into public events to connect directly with our amazing community. Our goal? To
        amplify Miami Lakers’ voices and ensure that no deaths or serious injuries occur on our
        Town’s roads.
      </Typography>

      <Typography variant="h5" gutterBottom>
        Join Us at These September Events!
      </Typography>

      <Typography paragraph>
        Whether you're a transit enthusiast, a community advocate, or just curious about Vision Zero,
        we’ve got something for everyone:
      </Typography>

<ul style={{ listStyle: 'none', padding: 0 }}>
  <li>
    <strong>Miami-Dade TPO Bicycle Pedestrian Advisory Committee</strong><br />
    September 9, 2PM–4PM | Free<br />
    150 W Flagler St, Suite 1900, Miami, FL 33031<br />
    Are you an active pedestrian or bicyclist? Join us and learn how Vision Zero aligns with
    both Town and County goals.
  </li>
  <Divider sx={{ my: 2 }} />

  <li>
    <strong>Miami Lakes Chamber of Commerce Monthly Luncheon</strong><br />
    September 10, 11AM–1PM | $55 non-members / $45 members<br />
    6842 Main Street, Miami Lakes, FL 33014<br />
    Network with local leaders and explore how Vision Zero fits into the Town’s future!
  </li>
  <Divider sx={{ my: 2 }} />

  <li>
    <strong>Miami-Dade TPO Freight Technical Advisory Committee</strong><br />
    September 10, 2PM–4PM | Free<br />
    150 W Flagler St, Suite 1900, Miami, FL 33031<br />
    Dive into how freight traffic can align with Vision Zero safety goals.
  </li>
  <Divider sx={{ my: 2 }} />

  <li>
    <strong>Let’s Take the Bus, Miami Lakes!</strong><br />
    September 15, 10AM–12PM | Free<br />
    15151 NW 82 Avenue, Miami Lakes, FL 33016<br />
    Hop on board for a fun, interactive transit adventure! We’ll explore the Town’s bus system
    and gather your feedback.
  </li>
  <Divider sx={{ my: 2 }} />

  <li>
    <strong>Senior Bingo Luncheon</strong><br />
    September 18, 10AM–1PM | Free<br />
    16500 NW 87 Avenue, Miami Lakes, FL 33018<br />
    Bingo, lunch, and Vision Zero? Count us in! Let’s chat about safe streets while enjoying
    some classic fun.
  </li>
</ul>

      <Typography variant="h5" gutterBottom>
        Dive Deeper at Committee Meetings
      </Typography>

      <Typography paragraph>
        Want to learn more about Vision Zero and how it connects with different community committees?
        Join us at these informative sessions:
      </Typography>

      <ul style={{ listStyle: 'none', padding: 0 }}>
        <li>
          <strong>Special Needs Advisory Board Meeting</strong><br />
          September 17, 5:30PM–7PM<br />
          Town Hall, 6601 Main Street, Miami Lakes, FL 33014
        </li>
        <Divider sx={{ my: 2 }} />
        <li>
          <strong>Neighborhood Improvement Committee Meeting</strong><br />
          September 17, 8:30PM–10PM<br />
          Town Hall, 6601 Main Street, Miami Lakes, FL 33014
        </li>
        <Divider sx={{ my: 2 }} />
        <li>
          <strong>Public Safety Committee Meeting</strong><br />
          September 23, 7PM–8:30PM<br />
          Town Hall, 6601 Main Street, Miami Lakes, FL 33014
        </li>
      </ul>

      <Typography paragraph>
        We encourage you to continue participating in our efforts. Join the conversation through our
        social media channels:
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <InstagramIcon color="action" />
          <Link
            href="https://www.instagram.com/miamilakesvisionzero"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="inherit"
            sx={{ fontWeight: 500 }}
          >
            @miamilakesvisionzero
          </Link>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <XIcon color="action" />
          <Link
            href="https://twitter.com/miamilakesvz"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="inherit"
            sx={{ fontWeight: 500 }}
          >
            @miamilakesvz
          </Link>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <FacebookIcon color="action" />
          <Link
            href="https://www.facebook.com/share/1HS7Sy2A9Z/?mibextid=wwXIfr"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="inherit"
            sx={{ fontWeight: 500 }}
          >
            Vision Zero Miami Lakes
          </Link>
        </Box>
      </Box>

      <Typography paragraph>
        Let’s continue making Miami Lakes a safer, more connected community together!
      </Typography>
    </Box>
  );
};

export default VZTakesMiamiLakesByStorm;
